<template>
  <v-card class="rounded-lg white">
    <span v-show="false">{{title}}</span>
    <balance-sheet-tabs v-if="!isDialog" :detailed="detailed"></balance-sheet-tabs>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="2" v-if="detailed">
          <v-select
              :menu-props="{ bottom: true, offsetY: true }"
              class="rounded-lg"
              label="سطح حساب"
              v-model="filters.level"
              item-text="text"
              item-value="value"
              :items="accountLevels"
              :return-object="false"
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-select
              :menu-props="{ bottom: true, offsetY: true }"
              class="rounded-lg"
              :items="accountStatuses"
              v-model="filters.status"
              label="وضعیت حساب"
          />
        </v-col>

        <v-col cols="8" class="d-flex flex-column flex-md-row">
          <date placeholder="از تاریخ" v-model="filters.from_date"/>
          <date class="mr-md-3 mt-1 mt-md-0" placeholder="تا تاریخ" v-model="filters.to_date"/>
          <v-switch
              inset
              color="success"
              class="mr-md-3 mt-3 mt-md-1"
              label="در نظر نگرفتن سند بستن"
              v-model="filters.skip_closing_sanads"
          ></v-switch>
          <v-btn
              :block="isXs"
              depressed
              class="success rounded-lg white--text w-100px mt-1 mr-5 md-5  "
              @click="getData()"
          >گزارش
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
              icon
              :href="this.endpoint('reports/balanceSheet/html') + `?detailed=${detailed == true}&token=${token}`"
              target="_blank"
              depressed
              class="secondary--text export-btn  mr-md-2 ">
            <v-img max-height="22" max-width="22" src="/img/icons/print_icon.svg"></v-img>
          </v-btn>
          <v-btn
              :href="this.endpoint('reports/balanceSheet/pdf') + `?detailed=${detailed == true}&token=${token}`"
              target="_blank"
              depressed
              icon
              class="secondary--text export-btn  mr-md-2"
          >
            <v-img max-height="22" max-width="22" src="/img/icons/pdf.svg"></v-img>
          </v-btn>

          <v-btn
              :href="this.endpoint('reports/balanceSheet/xlsx') + `?detailed=${detailed == true}&token=${token}`"
              target="_blank"
              depressed
              icon
              class="secondary--text export-btn  mr-md-2"
          >
            <v-img max-height="18" max-width="16" src="/img/icons/xls.svg"></v-img>
          </v-btn>

        </v-col>

        <template v-if="!_.isEmpty(d)">
          <v-col cols="12" md="6">
            <v-simple-table class="rounded">
              <thead class="back">
              <tr>
                <th colspan="2" class="text-center">دارایی ها</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <th colspan="2" class="text-center">دارایی های جاری</th>
              </tr>
              <tr>
                <td>{{ d.cacheAndBank.name }}</td>
                <td>{{ d.cacheAndBank.remain }}</td>
              </tr>
              <tr>
                <td>{{ d.shortTimeInvestments.name }}</td>
                <td>{{ d.shortTimeInvestments.remain }}</td>
              </tr>
              <tr>
                <td>{{ d.commercialAccountsAndReceivables.name }}</td>
                <td>{{ d.commercialAccountsAndReceivables.remain }}</td>
              </tr>
              <tr>
                <td>{{ d.otherAccountsAndReceivables.name }}</td>
                <td>{{ d.otherAccountsAndReceivables.remain }}</td>
              </tr>
              <tr>
                <td>{{ d.inventories.name }}</td>
                <td>{{ d.inventories.remain }}</td>
              </tr>
              <tr>
                <td>{{ d.ordersAndPrepayments.name }}</td>
                <td>{{ d.ordersAndPrepayments.remain }}</td>
              </tr>
              <tr class="font-weight-bold">
                <td>{{ d.totalCurrentAssets.name }}</td>
                <td>{{ d.totalCurrentAssets.remain }}</td>
              </tr>
              <tr>
                <th colspan="2" class="text-center">دارایی های غیر جاری</th>
              </tr>
              <tr>
                <td>{{ d.evidentFixedAssets.name }}</td>
                <td>{{ d.evidentFixedAssets.remain }}</td>
              </tr>
              <tr>
                <td>{{ d.notEvidentAssets.name }}</td>
                <td>{{ d.notEvidentAssets.remain }}</td>
              </tr>
              <tr>
                <td>{{ d.longTimeInvestments.name }}</td>
                <td>{{ d.longTimeInvestments.remain }}</td>
              </tr>
              <tr>
                <td>{{ d.otherAssets.name }}</td>
                <td>{{ d.otherAssets.remain }}</td>
              </tr>
              <tr class="font-weight-bold">
                <td>{{ d.totalNotCurrentAssets.name }}</td>
                <td>{{ d.totalNotCurrentAssets.remain }}</td>
              </tr>
              <tr class="font-weight-bold info--text">
                <td>{{ d.totalAssets.name }}</td>
                <td>{{ d.totalAssets.remain }}</td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-col>
          <v-col cols="12" md="6">
            <v-simple-table dense>
              <thead class="grey lighten-3">
              <tr>
                <th colspan="2" class="text-center">بدهی ها و حقوق صاحبان سهام</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <th colspan="2" class="text-center">بدهی های جاری</th>
              </tr>
              <tr>
                <td>{{ d.businessAccountsAndPayableDocuments.name }}</td>
                <td>{{ d.businessAccountsAndPayableDocuments.remain }}</td>
              </tr>
              <tr>
                <td>{{ d.otherAccountsAndPayableDocuments.name }}</td>
                <td>{{ d.otherAccountsAndPayableDocuments.remain }}</td>
              </tr>
              <tr>
                <td>{{ d.prepayments.name }}</td>
                <td>{{ d.prepayments.remain }}</td>
              </tr>
              <tr>
                <td>{{ d.saveTypes.name }}</td>
                <td>{{ d.saveTypes.remain }}</td>
              </tr>
              <tr>
                <td>{{ d.paidDividends.name }}</td>
                <td>{{ d.paidDividends.remain }}</td>
              </tr>
              <tr>
                <td>{{ d.receivableFunds.name }}</td>
                <td>{{ d.receivableFunds.remain }}</td>
              </tr>
              <tr class="font-weight-bold">
                <td>{{ d.totalCurrentDebt.name }}</td>
                <td>{{ d.totalCurrentDebt.remain }}</td>
              </tr>
              <tr>
                <th colspan="2" class="text-center">بدهی های غیر جاری</th>
              </tr>
              <tr>
                <td>{{ d.longtermAccountsAndPayableDocuments.name }}</td>
                <td>{{ d.longtermAccountsAndPayableDocuments.remain }}</td>
              </tr>
              <tr>
                <td>{{ d.longtermReceivableFunds.name }}</td>
                <td>{{ d.longtermReceivableFunds.remain }}</td>
              </tr>
              <tr>
                <td>{{ d.savedEndingServiceBenefits.name }}</td>
                <td>{{ d.savedEndingServiceBenefits.remain }}</td>
              </tr>
              <tr class="font-weight-bold">
                <td>{{ d.totalNotCurrentDebt.name }}</td>
                <td>{{ d.totalNotCurrentDebt.remain }}</td>
              </tr>
              <tr class="font-weight-bold">
                <td>{{ d.totalDebt.name }}</td>
                <td>{{ d.totalDebt.remain }}</td>
              </tr>
              <tr>
                <th colspan="2" class="text-center">حقوق صاحبان سهام</th>
              </tr>
              <tr>
                <td>{{ d.fund.name }}</td>
                <td>{{ d.fund.remain }}</td>
              </tr>
              <tr>
                <td>{{ d.savings.name }}</td>
                <td>{{ d.savings.remain }}</td>
              </tr>
              <tr>
                <td>{{ d.accumulatedProfit.name }}</td>
                <td>{{ d.accumulatedProfit.remain }}</td>
              </tr>
              <tr class="font-weight-bold">
                <td>{{ d.equitiesSum.name }}</td>
                <td>{{ d.equitiesSum.remain }}</td>
              </tr>
              <tr class="font-weight-bold info--text">
                <td>{{ d.totalDebtsAndEquities.name }}</td>
                <td>{{ d.totalDebtsAndEquities.remain }}</td>
              </tr>
              <tr :class="(d.remainDifference.remain)?
              'font-weight-bold primary--text':'font-weight-bold success--text'"
              style="font-size: larger"
              >
                <td>{{ d.remainDifference.name }}</td>
                <td v-if="d.remainDifference.remain">{{ d.remainDifference.remain }}</td>
                <td v-else>ندارد</td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </template>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import date from "@/components/mcomponents/cleave/Date";
import _ from "lodash";
import BalanceSheetTabs from "@/views/panel/balanceSheet/BalanceSheetTab";

export default {
  name: "BalanceSheet",
  components: {BalanceSheetTabs, date},
  props: {
    detailed: {
      default: false,
    },
    isDialog: {
      default: false
    },
  },
  data() {
    return {
      d: {},
      filters: {level: 3, status: 'with_transaction', skip_closing_sanads: false},
      accountStatuses: [
        {value: "all", text: "همه"},
        {value: "with_remain", text: "حساب های دارای مانده"},
        {value: "with_transaction", text: "حساب های دارای گردش"},
      ],
      accountLevels: [
        {value: 1, text: "کل"},
        {value: 2, text: "معین"},
        {value: 3, text: "تفضیلی"},
      ],
    };
  },
  created() {
    this.getData();
  },
  updated() {
    if (this.$route.params.detailed) {
      this.detailed = true
    }

  },

  methods: {
    getData() {
      let filters = {};
      for (const k of Object.keys(this.filters)) {
        if (["undefined", ""].includes(this.filters[k])) return;
        if (k.includes("date") || k.includes("due")) {
          let gDate = this.toGDate(this.filters[k]);
          if (gDate == "Invalid date") {
            this.notify("فرمت تاریخ وارد شده معتبر نمی باشد", "danger");
            return;
          }
          filters[k] = gDate;
        } else {
          filters[k] = this.filters[k];
        }
      }

      return this.request({
        url: this.endpoint("reports/balanceSheet"),
        method: "get",
        params: {
          ...this.filters,
        },
        success: (data) => {
          this.d = data;
          Object.keys(this.d).forEach((k) => {
            this.d[k].remain = this.toMoney(this.d[k].remain);
          });
        },
      });
    },
  },
  computed: {
    _() {
      return _;
    },
    title(){
      if (this.detailed){
        return this.setDocumentTitle('ترازنامه جزئی')

      } else {
        return this.setDocumentTitle('ترازنامه کلی')
      }
    },

  },
};
</script>

<style scoped lang="scss">
th {
  text-align: center;
}

td {
  width: 50%;
}

tr td:nth-child(2) {
  text-align: left;
  direction: ltr;
}
</style>
